import { isTagetCpaHigherThanBudget, getLogString } from './utils';

export const LogTargetCpaCheckOnSave = (i18n, permissions, budgetAmount, cpa, activity, scenario) => {
  if (permissions?.dynamic?.TargetCpaValueCheck) {
    const checkValue = isTagetCpaHigherThanBudget(i18n, budgetAmount, cpa);
    activity.trace(getLogString(checkValue, budgetAmount, cpa, scenario, true));
  }
};
